import instance from "./request";

//获取客服链接
export function getCustomerUrl(value:any) {
    return instance.post('/user/getCustomerUrl',value);
}

/**充值渠道查询 */
export function depWay(value:any) {
    return instance.post('/payIn/amount/list',value);
}

/**充值渠道查询 */
export function getPayChannelList(value:any) {
    return instance.post('/payIn/bank/list',value);
}

//充值记录
export function rechargeRecord(value:any) {
    return instance.post('/game/rechargeRecord',value);
}

//提现记录
export function withdrawRecord(value:any) {
    return instance.post('/game/withdrawRecord',value);
}

/**创建订单 */
export function createOrder(value:any) {
    return instance.post('/payIn/create/order',value);
}

//获取分享链接
export function getShareLink(value:any) {
    return instance.post('/v4/bus/getUserShareUrlAndExtensionCode',value);
}

//查询账户信息
export function createDrawOrder(value:any) {
    return instance.post('/payOut/create/order',value);
}

/**获取银行列表 */
export function getBankArr(value:any) {
    return instance.post('/payOut/bank/list',value);
}

/**获取玩家输赢信息 */
export function listGameRecords(value:any) {
    return instance.post('/user/listGameRecords',value);
}

/**提现订单进度获取 */
export function getProcess(value:any) {
    return instance.post('/v4/bus/getWithdrawProcess',value);
}

/**修改用户提现账户信息 */
export function updateCpf(value:any) {
    return instance.post('/v4/bus/updateAccount',value);
}

//获取任务进度
export function getTaskProcess(value: any) {
    return instance.post('/v4/bus/getTaskProcess', value);
}